export const customObjectsUserRelationshipTypeAttributes = "/data_objects/user_relationship_type_attributes";
